import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { FaCheckCircle, FaCar } from 'react-icons/fa';
import PartnersSection from '../components/PartnersSection';

const About = () => {
  const { t } = useLanguage();

  const specialties = [
    { name: 'Mercedes-Benz' },
    { name: 'BMW' },
    { name: 'Audi' },
    { name: 'Volkswagen' },
    { name: 'Mini Cooper' },
    { name: 'Toyota Hybrid' },
    { name: 'Honda Hybrid' }
  ];

  const values = [
    { title: t('about.integrity'), description: 'Honest diagnostics and transparent pricing' },
    { title: t('about.quality'), description: 'Premium parts and professional workmanship' },
    { title: t('about.professionalism'), description: 'Certified technicians and modern equipment' },
    { title: t('about.satisfaction'), description: 'Dedicated to exceeding expectations' }
  ];

  return (
    <div className="min-h-screen" data-testid="about-page">
      {/* Hero Section */}
      <section className="relative h-[400px] flex items-center bg-cover bg-center"
        style={{ backgroundImage: 'url(https://customer-assets.emergentagent.com/job_premium-workshop-1/artifacts/fyzgh57f_Workshop3.jpeg)' }}
      >
        <div className="absolute inset-0 bg-dark-navy/80"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 w-full text-center">
          <h1 className="font-cabinet font-extrabold text-4xl sm:text-5xl lg:text-6xl text-white mb-4">
            {t('about.title')}
          </h1>
          <p className="text-lg text-gray-200">{t('about.heading')}</p>
        </div>
      </section>

      {/* About Content */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="text-royal-blue font-semibold text-sm tracking-widest uppercase mb-4">
                Our Company
              </div>
              <h2 className="font-cabinet font-bold text-2xl sm:text-3xl text-dark-navy mb-6">
                LENG KEE AUTO SERVICE CENTRE SDN BHD
              </h2>
              <p className="text-base text-gray-600 leading-relaxed mb-6">
                {t('about.description')}
              </p>
              <p className="text-base text-gray-600 leading-relaxed mb-6">
                Our mission is to provide honest diagnostics, transparent pricing and professional workmanship for every customer. With over 15 years of industry experience, we have established ourselves as one of the leading European & Hybrid vehicle workshops in Muar, Johor.
              </p>
              <p className="text-base text-gray-600 leading-relaxed">
                Our spacious workshop features multiple service bays, dealer-level diagnostic equipment, and specialized hybrid battery service tools. We are committed to delivering premium automotive care with a focus on customer satisfaction.
              </p>
            </div>
            <div>
              <img 
                src="https://customer-assets.emergentagent.com/job_premium-workshop-1/artifacts/2n9vqk2w_Workshop%20Front.png" 
                alt="Leng Kee Auto Service Centre - Workshop Storefront" 
                className="w-full h-[500px] object-cover border border-gray-200 shadow-lg"
              />
              <p className="text-center text-sm text-gray-500 mt-3 italic">
                Our workshop storefront in Muar, Johor
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Specialties */}
      <section className="py-24 bg-light-grey">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <h2 className="font-cabinet font-bold text-2xl sm:text-3xl text-dark-navy mb-12 text-center">
            {t('about.specialties')}
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-8">
            {specialties.map((specialty, index) => (
              <div key={index} className="flex flex-col items-center text-center">
                <div className="text-royal-blue mb-3">
                  <FaCar size={32} />
                </div>
                <span className="text-sm font-medium text-dark-navy">{specialty.name}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Core Values */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <h2 className="font-cabinet font-bold text-2xl sm:text-3xl text-dark-navy mb-12 text-center">
            {t('about.values')}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {values.map((value, index) => (
              <div key={index} className="flex items-start space-x-4 p-6 border border-gray-200 hover:shadow-md transition-shadow">
                <FaCheckCircle className="text-royal-blue text-2xl flex-shrink-0 mt-1" />
                <div>
                  <h3 className="font-cabinet font-semibold text-xl text-dark-navy mb-2">
                    {value.title}
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed">{value.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Our Strategic Partners */}
      <PartnersSection />
    </div>
  );
};

export default About;